module.exports = {"data":{"site":{"siteMetadata":{"siteTitle":"Engularity","siteDescr":"Eng[ineering with Mod]ularity.","siteAuthor":"Jacob Bolda","siteEmail":"me@jacobbolda.com","siteTwitterUrl":"https://twitter.com/jacob_bolda","siteTwitterPretty":"@jacob_bolda"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-inset-page.json
// module id = 117
// module chunks = 60335399758886 233985820157477